/* InstaCuppa A+ by colour (2026-10-07). Swaps the Premium A+ image sources in the Product Details tab to the
   selected variant's colour. Data comes from snippets/ic-aplus-color.liquid (<script data-ic-aplus-data>), which
   is only rendered for products with the custom.aplus_by_color metafield - everywhere else this file exits at once.
   Only src/srcset/alt attributes change: no nodes are added or removed (carousel, mid-page CTA and zoom keep
   working), and images stay loading="lazy", so colours nobody looks at are never downloaded. */
(function () {
  'use strict';
  var data = null;

  function read() {
    var el = document.querySelector('script[data-ic-aplus-data]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }
  function main() {
    return document.querySelector('product-info[id^="MainProduct-"]') || document.querySelector('[id^="MainProduct-"]') || document;
  }
  function optionBlock(name) {
    var re = /^colou?r$/i.test(name) ? /colou?r/i : new RegExp(name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'i');
    var blocks = main().querySelectorAll('.product-form__input');
    for (var i = 0; i < blocks.length; i++) {
      var lbl = blocks[i].querySelector('legend, label');
      if (lbl && re.test(lbl.textContent)) return blocks[i];
    }
    return null;
  }
  function variantColour(id) {
    return id && data.variants && Object.prototype.hasOwnProperty.call(data.variants, String(id)) ? data.variants[String(id)] : null;
  }
  // the colour the shopper picked (even if that combination is sold out)
  function selectedColour(hintVariant) {
    if (hintVariant && hintVariant.id && variantColour(hintVariant.id)) return variantColour(hintVariant.id);
    var block = optionBlock(data.config.option || 'Color');
    if (block) {
      var chk = block.querySelector('input:checked'); if (chk && chk.value) return chk.value.trim();
      var sel = block.querySelector('select'); if (sel && sel.value) return sel.value.trim();
    }
    var idEl = main().querySelector('form[action*="/cart/add"] [name="id"]');
    if (idEl && variantColour(idEl.value)) return variantColour(idEl.value);
    var m = /[?&]variant=(\d+)/.exec(location.search);
    if (m && variantColour(m[1])) return variantColour(m[1]);
    return null;
  }
  function setFor(colour) {
    var colors = data.config.colors || {}, keys = Object.keys(colors);
    if (colour) {
      for (var i = 0; i < keys.length; i++) {
        if (keys[i].toLowerCase() === String(colour).toLowerCase() && colors[keys[i]] && colors[keys[i]].desktop) return keys[i];
      }
    }
    return colors[data.config['default']] ? data.config['default'] : null;
  }

  // 2026-10-07: post-A+ CTA mirrors the MAIN add-to-cart button (Dawn sets it to "Sold out"/"Unavailable" and
  // disables it) and shows the live variant's price; clicking it clicks the main form's submit, like the sticky bar.
  function mainSubmit() {
    return main().querySelector('form[action*="/cart/add"] button[type="submit"], .product-form button[name="add"]') ||
      document.querySelector('.product-form button[name="add"], form[action*="/cart/add"] button[type="submit"]');
  }
  function updateCta() {
    var btns = document.querySelectorAll('[data-ic-aplus-atc]');
    if (!btns.length) return;
    var sub = mainSubmit();
    var idEl = main().querySelector('form[action*="/cart/add"] [name="id"]');
    var info = idEl && data.vinfo ? data.vinfo[String(idEl.value)] : null;
    var disabled = sub ? sub.disabled : (info ? !info[1] : false);
    var label;
    if (disabled) {
      label = (sub && (sub.textContent || '').replace(/\s+/g, ' ').trim()) || 'Sold out';
    } else if (info) {
      // the theme's own money format (window.croMoney in layout/theme.liquid follows Admin's format and drops .00 - same as the main price)
      var money = typeof window.croMoney === 'function' ? window.croMoney(info[0]) : 'Rs. ' + (info[0] / 100).toLocaleString('en-IN', { maximumFractionDigits: 2 });
      label = 'Add to cart \u2014 ' + money;
    } else {
      return; // no variant info yet: keep the server-rendered label
    }
    for (var i = 0; i < btns.length; i++) {
      if (btns[i].textContent !== label) btns[i].textContent = label;
      if (btns[i].disabled !== disabled) btns[i].disabled = disabled;
    }
  }

  // 2026-10-25 size guard: data.allow = {variantId: bool} when the metafield has "require" (e.g. Aero: Size = 600 ML).
  // A disallowed variant hides every A+ copy and its CTA; an allowed one shows them. No "require" -> data.allow is null.
  function allowedFor(hintVariant) {
    if (!data.allow) return true;
    var vid = hintVariant && hintVariant.id ? String(hintVariant.id) : null;
    if (!vid) { var idEl = main().querySelector('form[action*="/cart/add"] [name="id"]'); if (idEl && idEl.value) vid = String(idEl.value); }
    if (!vid) { var m = /[?&]variant=(\d+)/.exec(location.search); if (m) vid = m[1]; }
    return vid && Object.prototype.hasOwnProperty.call(data.allow, vid) ? !!data.allow[vid] : true;
  }

  function apply(hintVariant) {
    if (!data) return;
    try { updateCta(); } catch (e) {}
    var ok = allowedFor(hintVariant);
    var boxes = document.querySelectorAll('[data-ic-aplus], [data-ic-aplus-cta]');
    for (var b = 0; b < boxes.length; b++) if (boxes[b].hidden === ok) boxes[b].hidden = !ok;
    if (!ok) return;
    var shown = setFor(selectedColour(hintVariant));
    if (!shown) return;
    var set = data.config.colors[shown], mods = data.config.modules || [], prefix = data.config.alt_prefix || '';
    // every rendered copy (desktop tab + mobile accordion, or a re-injected tab) is brought in line; already-right copies are skipped
    var roots = document.querySelectorAll('[data-ic-aplus]');
    for (var r = 0; r < roots.length; r++) {
      var root = roots[r];
      if (root.getAttribute('data-ic-aplus-shown') === shown) continue;
      root.querySelectorAll('img[data-ic-aplus-img]').forEach(function (img) {
        var i = +img.getAttribute('data-ic-aplus-img');
        if (set.desktop[i]) img.setAttribute('src', set.desktop[i]);
        if (mods[i]) img.setAttribute('alt', prefix + ' - ' + shown + ' - ' + mods[i].alt);
      });
      root.querySelectorAll('source[data-ic-aplus-src]').forEach(function (s) {
        var i = +s.getAttribute('data-ic-aplus-src');
        var u = (set.mobile && set.mobile[i]) || set.desktop[i];
        if (u) s.setAttribute('srcset', u);
      });
      root.setAttribute('data-ic-aplus-shown', shown);
    }
  }
  // THROTTLE, never debounce: the gallery's slide counter is rewritten every ~100 ms by cro-variant-images.js,
  // which would starve a debounce timer forever (seen in testing 2026-10-07).
  var t = null;
  function later(ms) { if (t) return; t = setTimeout(function () { t = null; apply(); }, ms || 80); }

  function boot() {
    data = read();
    if (!data || !data.config || !data.config.colors) return; // not an A+-by-colour product: do nothing
    apply();
    document.addEventListener('click', function (e) {
      var b = e.target && e.target.closest && e.target.closest('[data-ic-aplus-atc]');
      if (!b || b.disabled) return;
      var sub = mainSubmit();
      if (sub && !sub.disabled) sub.click();
    });
    document.addEventListener('change', function (e) {
      if (e.target && e.target.closest && e.target.closest('variant-selects, variant-radios, .product-form__input, form[action*="/cart/add"]')) {
        setTimeout(apply, 30); setTimeout(apply, 400); // own timers: never cancelled by the observer
      }
    });
    // Dawn 15 publishes the new variant after it re-renders the buy box
    try {
      if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.variantChange) {
        subscribe(PUB_SUB_EVENTS.variantChange, function (ev) { apply(ev && ev.data && ev.data.variant); });
      }
    } catch (e) {}
    // Dawn swaps the picker markup on variant change; a re-injected tab also lands here. apply() is idempotent.
    try { new MutationObserver(function () { later(90); }).observe(document.body, { childList: true, subtree: true }); } catch (e) {}
    window.addEventListener('pageshow', function () { later(0); });
    window.addEventListener('popstate', function () { later(0); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
